<script setup>
import EvacManagerPatientStrip from "@/components/hpo/dashboard/patientListItems/EvacManagerPatientStrip.vue";
import {ref} from "vue";
import DestinationHospitalModal from "@/components/hpo/dashboard/DestinationHospitalModal.vue";

const props = defineProps({
    hpo: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    hospitalList: {
        type: Object,
        required: true
    },
    patientList: {
        type: Array,
        required: true
    },
    alertList: {
        type: Array,
        required: true
    },
    now: {
        type: Object,
        required: true
    }
});
const emit = defineEmits(['openReplyModal', 'displayActionsModal', 'displayTransportWizard'])

const editedTransportData = ref(null);

function handleDisplayActionsModal(patient) {
    emit('displayActionsModal', patient)
}

function handleOpenReplyModal(reply, patient) {
    emit('openReplyModal', reply, patient)
}

function handleSetEditedTransportData(patient) {
    editedTransportData.value = patient
}

function handleDisplayTransportWizard(patient) {
    emit('displayTransportWizard', patient)
}
</script>

<template>
    <div class="hpo-patients-list-evac-manager">
        <EvacManagerPatientStrip v-for="patient in patientList"
                                 :key="patient.id"
                                 :patient="patient"
                                 :member="member"
                                 :alertList="alertList"
                                 :now="now"
                                 @displayActionsModal="handleDisplayActionsModal"
                                 @setEditedTransportData="handleSetEditedTransportData"
                                 @openReplyModal="handleOpenReplyModal"
                                 @displayTransportWizard="handleDisplayTransportWizard"/>
    </div>

    <DestinationHospitalModal v-if="editedTransportData"
                              :patient="editedTransportData"
                              :hospitalList="hospitalList"
                              @close="editedTransportData=null"/>
</template>
